import { css } from '@emotion/core';
import { Link } from 'react-router-dom';

const HeaderTab = ({ selected, path, label }) => {
    return (
        <li
            css={css`
                height: 100%;
                list-style: none;
            `}
        >
            <Link
                css={css`
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    font-size: 1.6666rem;
                    box-sizing: border-box;
                    border-top: solid 8px transparent;
                    border-bottom: solid 8px ${selected ? '#f8972b' : 'transparent'};
                    color: ${selected ? '#f8972b' : '#fff'};
                    font-weight: ${selected ? 'bold' : 'normal'};
                    text-decoration: none;

                    &:hover,
                    &:focus {
                        color: #f8972b;
                    }
                `}
                to={path}
            >
                {label}
            </Link>
        </li>
    );
};
export default HeaderTab;
